import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

import { AuthService } from '../auth.service';
import { TextboxQuestion } from '@core/components/forms/question-textbox';
import { QuestionControlService } from '@core/components';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  credentials = {
    username: '',
    sid: ''
  };
  error: any;
  loading = false;
  supportUrl: string;
  done = false;

  formGroup = null;
  usernameQuestion = null;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private titleService: Title,
    private qcs: QuestionControlService
  ) {}

  public ngOnInit(): void {
    this.authService.logout();
    this.credentials.username = this.route.snapshot.queryParamMap.get('username');
    this.credentials.sid = this.route.snapshot.queryParamMap.get('sid');
    this.translate
      .get('auth.resetPassword')
      .subscribe((trans) => this.titleService.setTitle(trans));
    this.translate.get('urls.support').subscribe((trans) => (this.supportUrl = trans));

    this.usernameQuestion = new TextboxQuestion({
      key: 'username',
      type: 'email',
      value: this.credentials.username,
      validators: { required: true, mail: true }
    });
    this.formGroup = this.qcs.toFormGroup([this.usernameQuestion]);
  }

  public onSubmit(): void {
    this.credentials = { ...this.credentials, ...this.formGroup.value };
    this.error = null;
    this.loading = true;
    this.authService.requestAccountReset(this.credentials).subscribe({
      next: () => {
        this.done = true;
      },
      error: (error) => {
        this.onError(error);
      }
    });
  }

  public onError(error: any): void {
    this.loading = false;
    this.error = error
      ? Object.assign({}, error, {
          errorCode: `apiErrors.${error.errorCode || 'SYSTEM_ERROR'}`
        })
      : null;
  }
}
